// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file permission.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "./google/protobuf/timestamp_pb";
import { file_google_protobuf_timestamp } from "./google/protobuf/timestamp_pb";
import type { EmptyResponseSchema } from "./basic_pb";
import { file_basic } from "./basic_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file permission.proto.
 */
export const file_permission: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_basic]);

/**
 * 权限角色列表请求
 *
 * @generated from message puppy.proto.v1.ListPermissionRolesRequest
 */
export type ListPermissionRolesRequest = Message<"puppy.proto.v1.ListPermissionRolesRequest"> & {
  /**
   * 页码（从 1 开始，具体以服务端约定为准）
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页条数
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * 搜索关键字
   *
   * @generated from field: string search = 3;
   */
  search: string;
};

/**
 * Describes the message puppy.proto.v1.ListPermissionRolesRequest.
 * Use `create(ListPermissionRolesRequestSchema)` to create a new message.
 */
export const ListPermissionRolesRequestSchema: GenMessage<ListPermissionRolesRequest> = /*@__PURE__*/
  messageDesc(file_permission, 0);

/**
 * 权限角色列表响应
 *
 * @generated from message puppy.proto.v1.ListPermissionRolesResponse
 */
export type ListPermissionRolesResponse = Message<"puppy.proto.v1.ListPermissionRolesResponse"> & {
  /**
   * 角色列表
   *
   * @generated from field: repeated puppy.proto.v1.PermissionRole roles = 1;
   */
  roles: PermissionRole[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.ListPermissionRolesResponse.
 * Use `create(ListPermissionRolesResponseSchema)` to create a new message.
 */
export const ListPermissionRolesResponseSchema: GenMessage<ListPermissionRolesResponse> = /*@__PURE__*/
  messageDesc(file_permission, 1);

/**
 * 获取权限角色请求
 *
 * @generated from message puppy.proto.v1.GetPermissionRoleRequest
 */
export type GetPermissionRoleRequest = Message<"puppy.proto.v1.GetPermissionRoleRequest"> & {
  /**
   * 角色 ID
   *
   * @generated from field: uint64 role_id = 1;
   */
  roleId: bigint;
};

/**
 * Describes the message puppy.proto.v1.GetPermissionRoleRequest.
 * Use `create(GetPermissionRoleRequestSchema)` to create a new message.
 */
export const GetPermissionRoleRequestSchema: GenMessage<GetPermissionRoleRequest> = /*@__PURE__*/
  messageDesc(file_permission, 2);

/**
 * 权限角色
 *
 * @generated from message puppy.proto.v1.PermissionRole
 */
export type PermissionRole = Message<"puppy.proto.v1.PermissionRole"> & {
  /**
   * 角色 ID
   *
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * 角色名称
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 角色描述
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 是否系统预设角色
   *
   * @generated from field: bool is_system = 4;
   */
  isSystem: boolean;

  /**
   * 创建时间
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * 更新时间
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * 创建者标识（用户名/ID 等，具体由服务端定义）
   *
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * 标签
   *
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * RBAC 权限开关
   *
   * 是否允许上传文件
   *
   * @generated from field: bool can_upload_files = 9;
   */
  canUploadFiles: boolean;

  /**
   * 是否允许下载文件
   *
   * @generated from field: bool can_download_files = 10;
   */
  canDownloadFiles: boolean;

  /**
   * 是否允许删除文件
   *
   * @generated from field: bool can_delete_files = 11;
   */
  canDeleteFiles: boolean;

  /**
   * 是否允许重命名文件
   *
   * @generated from field: bool can_rename_files = 12;
   */
  canRenameFiles: boolean;

  /**
   * 是否允许移动文件
   *
   * @generated from field: bool can_move_files = 13;
   */
  canMoveFiles: boolean;

  /**
   * 是否允许复制文件
   *
   * @generated from field: bool can_copy_files = 14;
   */
  canCopyFiles: boolean;

  /**
   * 是否允许创建文件夹
   *
   * @generated from field: bool can_create_folders = 15;
   */
  canCreateFolders: boolean;

  /**
   * 是否允许搜索文件
   *
   * @generated from field: bool can_search_files = 16;
   */
  canSearchFiles: boolean;

  /**
   * 是否允许创建分享
   *
   * @generated from field: bool can_create_shares = 17;
   */
  canCreateShares: boolean;

  /**
   * 是否允许管理分享（更新/删除等）
   *
   * @generated from field: bool can_manage_shares = 18;
   */
  canManageShares: boolean;

  /**
   * 是否允许查看自身配额
   *
   * @generated from field: bool can_view_own_quota = 19;
   */
  canViewOwnQuota: boolean;

  /**
   * 是否允许管理自身信息
   *
   * @generated from field: bool can_manage_own_info = 20;
   */
  canManageOwnInfo: boolean;

  /**
   * 是否允许管理子用户（增删改/重置密码/启停等）
   *
   * @generated from field: bool can_manage_sub_users = 26;
   */
  canManageSubUsers: boolean;

  /**
   * 是否允许管理权限角色（创建/更新/删除/分配）
   *
   * @generated from field: bool can_manage_permission_roles = 27;
   */
  canManagePermissionRoles: boolean;

  /**
   * ABAC 约束
   *
   * 允许的文件类型（例如扩展名/ MIME，具体以服务端约定为准）
   *
   * @generated from field: repeated string allowed_file_types = 21;
   */
  allowedFileTypes: string[];

  /**
   * 禁止的文件类型
   *
   * @generated from field: repeated string denied_file_types = 22;
   */
  deniedFileTypes: string[];

  /**
   * 允许的最大文件大小（字节）
   *
   * @generated from field: uint64 max_file_size = 23;
   */
  maxFileSize: bigint;

  /**
   * 允许访问的时间范围（字符串表达式，具体以服务端约定为准）
   *
   * @generated from field: string access_time_range = 24;
   */
  accessTimeRange: string;

  /**
   * 允许的 IP 白名单
   *
   * @generated from field: repeated string allowed_ips = 25;
   */
  allowedIps: string[];
};

/**
 * Describes the message puppy.proto.v1.PermissionRole.
 * Use `create(PermissionRoleSchema)` to create a new message.
 */
export const PermissionRoleSchema: GenMessage<PermissionRole> = /*@__PURE__*/
  messageDesc(file_permission, 3);

/**
 * 创建权限角色请求
 *
 * @generated from message puppy.proto.v1.CreatePermissionRoleRequest
 */
export type CreatePermissionRoleRequest = Message<"puppy.proto.v1.CreatePermissionRoleRequest"> & {
  /**
   * 角色名称
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 角色描述
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * RBAC 权限开关
   *
   * 是否允许上传文件
   *
   * @generated from field: bool can_upload_files = 3;
   */
  canUploadFiles: boolean;

  /**
   * 是否允许下载文件
   *
   * @generated from field: bool can_download_files = 4;
   */
  canDownloadFiles: boolean;

  /**
   * 是否允许删除文件
   *
   * @generated from field: bool can_delete_files = 5;
   */
  canDeleteFiles: boolean;

  /**
   * 是否允许重命名文件
   *
   * @generated from field: bool can_rename_files = 6;
   */
  canRenameFiles: boolean;

  /**
   * 是否允许移动文件
   *
   * @generated from field: bool can_move_files = 7;
   */
  canMoveFiles: boolean;

  /**
   * 是否允许复制文件
   *
   * @generated from field: bool can_copy_files = 8;
   */
  canCopyFiles: boolean;

  /**
   * 是否允许创建文件夹
   *
   * @generated from field: bool can_create_folders = 9;
   */
  canCreateFolders: boolean;

  /**
   * 是否允许搜索文件
   *
   * @generated from field: bool can_search_files = 10;
   */
  canSearchFiles: boolean;

  /**
   * 是否允许创建分享
   *
   * @generated from field: bool can_create_shares = 11;
   */
  canCreateShares: boolean;

  /**
   * 是否允许管理分享
   *
   * @generated from field: bool can_manage_shares = 12;
   */
  canManageShares: boolean;

  /**
   * 是否允许查看自身配额
   *
   * @generated from field: bool can_view_own_quota = 13;
   */
  canViewOwnQuota: boolean;

  /**
   * 是否允许管理自身信息
   *
   * @generated from field: bool can_manage_own_info = 14;
   */
  canManageOwnInfo: boolean;

  /**
   * 是否允许管理子用户
   *
   * @generated from field: bool can_manage_sub_users = 21;
   */
  canManageSubUsers: boolean;

  /**
   * 是否允许管理权限角色
   *
   * @generated from field: bool can_manage_permission_roles = 22;
   */
  canManagePermissionRoles: boolean;

  /**
   * 标签
   *
   * @generated from field: repeated string tags = 15;
   */
  tags: string[];

  /**
   * ABAC 约束
   *
   * 允许的文件类型
   *
   * @generated from field: repeated string allowed_file_types = 16;
   */
  allowedFileTypes: string[];

  /**
   * 禁止的文件类型
   *
   * @generated from field: repeated string denied_file_types = 17;
   */
  deniedFileTypes: string[];

  /**
   * 允许的最大文件大小（字节）
   *
   * @generated from field: uint64 max_file_size = 18;
   */
  maxFileSize: bigint;

  /**
   * 允许访问的时间范围
   *
   * @generated from field: string access_time_range = 19;
   */
  accessTimeRange: string;

  /**
   * 允许的 IP 白名单
   *
   * @generated from field: repeated string allowed_ips = 20;
   */
  allowedIps: string[];
};

/**
 * Describes the message puppy.proto.v1.CreatePermissionRoleRequest.
 * Use `create(CreatePermissionRoleRequestSchema)` to create a new message.
 */
export const CreatePermissionRoleRequestSchema: GenMessage<CreatePermissionRoleRequest> = /*@__PURE__*/
  messageDesc(file_permission, 4);

/**
 * 更新权限角色请求
 *
 * @generated from message puppy.proto.v1.UpdatePermissionRoleRequest
 */
export type UpdatePermissionRoleRequest = Message<"puppy.proto.v1.UpdatePermissionRoleRequest"> & {
  /**
   * 角色 ID
   *
   * @generated from field: uint64 role_id = 1;
   */
  roleId: bigint;

  /**
   * 可选：角色名称
   *
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * 可选：角色描述
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * RBAC 权限开关（可选）
   *
   * 是否允许上传文件
   *
   * @generated from field: optional bool can_upload_files = 4;
   */
  canUploadFiles?: boolean | undefined;

  /**
   * 是否允许下载文件
   *
   * @generated from field: optional bool can_download_files = 5;
   */
  canDownloadFiles?: boolean | undefined;

  /**
   * 是否允许删除文件
   *
   * @generated from field: optional bool can_delete_files = 6;
   */
  canDeleteFiles?: boolean | undefined;

  /**
   * 是否允许重命名文件
   *
   * @generated from field: optional bool can_rename_files = 7;
   */
  canRenameFiles?: boolean | undefined;

  /**
   * 是否允许移动文件
   *
   * @generated from field: optional bool can_move_files = 8;
   */
  canMoveFiles?: boolean | undefined;

  /**
   * 是否允许复制文件
   *
   * @generated from field: optional bool can_copy_files = 9;
   */
  canCopyFiles?: boolean | undefined;

  /**
   * 是否允许创建文件夹
   *
   * @generated from field: optional bool can_create_folders = 10;
   */
  canCreateFolders?: boolean | undefined;

  /**
   * 是否允许搜索文件
   *
   * @generated from field: optional bool can_search_files = 11;
   */
  canSearchFiles?: boolean | undefined;

  /**
   * 是否允许创建分享
   *
   * @generated from field: optional bool can_create_shares = 12;
   */
  canCreateShares?: boolean | undefined;

  /**
   * 是否允许管理分享
   *
   * @generated from field: optional bool can_manage_shares = 13;
   */
  canManageShares?: boolean | undefined;

  /**
   * 是否允许查看自身配额
   *
   * @generated from field: optional bool can_view_own_quota = 14;
   */
  canViewOwnQuota?: boolean | undefined;

  /**
   * 是否允许管理自身信息
   *
   * @generated from field: optional bool can_manage_own_info = 15;
   */
  canManageOwnInfo?: boolean | undefined;

  /**
   * 是否允许管理子用户
   *
   * @generated from field: optional bool can_manage_sub_users = 22;
   */
  canManageSubUsers?: boolean | undefined;

  /**
   * 是否允许管理权限角色
   *
   * @generated from field: optional bool can_manage_permission_roles = 23;
   */
  canManagePermissionRoles?: boolean | undefined;

  /**
   * 标签（整体替换，具体语义以服务端实现为准）
   *
   * @generated from field: repeated string tags = 16;
   */
  tags: string[];

  /**
   * ABAC 约束（整体替换，具体语义以服务端实现为准）
   *
   * 允许的文件类型
   *
   * @generated from field: repeated string allowed_file_types = 17;
   */
  allowedFileTypes: string[];

  /**
   * 禁止的文件类型
   *
   * @generated from field: repeated string denied_file_types = 18;
   */
  deniedFileTypes: string[];

  /**
   * 允许的最大文件大小（字节）
   *
   * @generated from field: optional uint64 max_file_size = 19;
   */
  maxFileSize?: bigint | undefined;

  /**
   * 允许访问的时间范围
   *
   * @generated from field: optional string access_time_range = 20;
   */
  accessTimeRange?: string | undefined;

  /**
   * 允许的 IP 白名单
   *
   * @generated from field: repeated string allowed_ips = 21;
   */
  allowedIps: string[];
};

/**
 * Describes the message puppy.proto.v1.UpdatePermissionRoleRequest.
 * Use `create(UpdatePermissionRoleRequestSchema)` to create a new message.
 */
export const UpdatePermissionRoleRequestSchema: GenMessage<UpdatePermissionRoleRequest> = /*@__PURE__*/
  messageDesc(file_permission, 5);

/**
 * 设置子用户权限角色请求
 *
 * @generated from message puppy.proto.v1.SetSubUserRolesRequest
 */
export type SetSubUserRolesRequest = Message<"puppy.proto.v1.SetSubUserRolesRequest"> & {
  /**
   * 子用户 ID
   *
   * @generated from field: uint64 sub_user_id = 1;
   */
  subUserId: bigint;

  /**
   * 角色 ID 列表
   *
   * @generated from field: repeated uint64 role_ids = 2;
   */
  roleIds: bigint[];
};

/**
 * Describes the message puppy.proto.v1.SetSubUserRolesRequest.
 * Use `create(SetSubUserRolesRequestSchema)` to create a new message.
 */
export const SetSubUserRolesRequestSchema: GenMessage<SetSubUserRolesRequest> = /*@__PURE__*/
  messageDesc(file_permission, 6);

/**
 * 获取子用户权限角色请求
 *
 * @generated from message puppy.proto.v1.GetSubUserRolesRequest
 */
export type GetSubUserRolesRequest = Message<"puppy.proto.v1.GetSubUserRolesRequest"> & {
  /**
   * 子用户 ID
   *
   * @generated from field: uint64 sub_user_id = 1;
   */
  subUserId: bigint;
};

/**
 * Describes the message puppy.proto.v1.GetSubUserRolesRequest.
 * Use `create(GetSubUserRolesRequestSchema)` to create a new message.
 */
export const GetSubUserRolesRequestSchema: GenMessage<GetSubUserRolesRequest> = /*@__PURE__*/
  messageDesc(file_permission, 7);

/**
 * @generated from message puppy.proto.v1.GetSubUserRolesResponse
 */
export type GetSubUserRolesResponse = Message<"puppy.proto.v1.GetSubUserRolesResponse"> & {
  /**
   * 角色 ID 列表
   *
   * @generated from field: repeated uint64 role_ids = 2;
   */
  roleIds: bigint[];
};

/**
 * Describes the message puppy.proto.v1.GetSubUserRolesResponse.
 * Use `create(GetSubUserRolesResponseSchema)` to create a new message.
 */
export const GetSubUserRolesResponseSchema: GenMessage<GetSubUserRolesResponse> = /*@__PURE__*/
  messageDesc(file_permission, 8);

/**
 * 删除权限角色请求
 *
 * @generated from message puppy.proto.v1.DeletePermissionRoleRequest
 */
export type DeletePermissionRoleRequest = Message<"puppy.proto.v1.DeletePermissionRoleRequest"> & {
  /**
   * 角色 ID
   *
   * @generated from field: uint64 role_id = 1;
   */
  roleId: bigint;
};

/**
 * Describes the message puppy.proto.v1.DeletePermissionRoleRequest.
 * Use `create(DeletePermissionRoleRequestSchema)` to create a new message.
 */
export const DeletePermissionRoleRequestSchema: GenMessage<DeletePermissionRoleRequest> = /*@__PURE__*/
  messageDesc(file_permission, 9);

/**
 * 应用权限角色请求
 *
 * @generated from message puppy.proto.v1.ApplyPermissionRolesRequest
 */
export type ApplyPermissionRolesRequest = Message<"puppy.proto.v1.ApplyPermissionRolesRequest"> & {
  /**
   * 角色 ID 列表
   *
   * @generated from field: repeated uint64 role_ids = 1;
   */
  roleIds: bigint[];

  /**
   * 子用户 ID 列表
   *
   * @generated from field: repeated uint64 sub_user_ids = 2;
   */
  subUserIds: bigint[];
};

/**
 * Describes the message puppy.proto.v1.ApplyPermissionRolesRequest.
 * Use `create(ApplyPermissionRolesRequestSchema)` to create a new message.
 */
export const ApplyPermissionRolesRequestSchema: GenMessage<ApplyPermissionRolesRequest> = /*@__PURE__*/
  messageDesc(file_permission, 10);

/**
 * 用户角色与权限/约束信息（RBAC/ABAC）
 *
 * @generated from message puppy.proto.v1.UserRoleAccess
 */
export type UserRoleAccess = Message<"puppy.proto.v1.UserRoleAccess"> & {
  /**
   * 绑定的角色 ID 列表
   *
   * @generated from field: repeated uint64 role_ids = 1;
   */
  roleIds: bigint[];

  /**
   * 合并后的 RBAC 权限
   *
   * @generated from field: puppy.proto.v1.UserRBACPermissions permissions = 2;
   */
  permissions?: UserRBACPermissions | undefined;

  /**
   * 合并后的 ABAC 约束
   *
   * @generated from field: puppy.proto.v1.RoleConstraints constraints = 3;
   */
  constraints?: RoleConstraints | undefined;
};

/**
 * Describes the message puppy.proto.v1.UserRoleAccess.
 * Use `create(UserRoleAccessSchema)` to create a new message.
 */
export const UserRoleAccessSchema: GenMessage<UserRoleAccess> = /*@__PURE__*/
  messageDesc(file_permission, 11);

/**
 * RBAC 权限开关（合并后）
 *
 * @generated from message puppy.proto.v1.UserRBACPermissions
 */
export type UserRBACPermissions = Message<"puppy.proto.v1.UserRBACPermissions"> & {
  /**
   * 是否允许上传文件
   *
   * @generated from field: bool can_upload_files = 1;
   */
  canUploadFiles: boolean;

  /**
   * 是否允许下载文件
   *
   * @generated from field: bool can_download_files = 2;
   */
  canDownloadFiles: boolean;

  /**
   * 是否允许删除文件
   *
   * @generated from field: bool can_delete_files = 3;
   */
  canDeleteFiles: boolean;

  /**
   * 是否允许重命名文件
   *
   * @generated from field: bool can_rename_files = 4;
   */
  canRenameFiles: boolean;

  /**
   * 是否允许移动文件
   *
   * @generated from field: bool can_move_files = 5;
   */
  canMoveFiles: boolean;

  /**
   * 是否允许复制文件
   *
   * @generated from field: bool can_copy_files = 6;
   */
  canCopyFiles: boolean;

  /**
   * 是否允许创建文件夹
   *
   * @generated from field: bool can_create_folders = 7;
   */
  canCreateFolders: boolean;

  /**
   * 是否允许搜索文件
   *
   * @generated from field: bool can_search_files = 8;
   */
  canSearchFiles: boolean;

  /**
   * 是否允许创建分享
   *
   * @generated from field: bool can_create_shares = 9;
   */
  canCreateShares: boolean;

  /**
   * 是否允许管理分享（更新/删除等）
   *
   * @generated from field: bool can_manage_shares = 10;
   */
  canManageShares: boolean;

  /**
   * 是否允许查看自身配额
   *
   * @generated from field: bool can_view_own_quota = 11;
   */
  canViewOwnQuota: boolean;

  /**
   * 是否允许管理自身信息
   *
   * @generated from field: bool can_manage_own_info = 12;
   */
  canManageOwnInfo: boolean;

  /**
   * 是否允许管理子用户
   *
   * @generated from field: bool can_manage_sub_users = 13;
   */
  canManageSubUsers: boolean;

  /**
   * 是否允许管理权限角色
   *
   * @generated from field: bool can_manage_permission_roles = 14;
   */
  canManagePermissionRoles: boolean;
};

/**
 * Describes the message puppy.proto.v1.UserRBACPermissions.
 * Use `create(UserRBACPermissionsSchema)` to create a new message.
 */
export const UserRBACPermissionsSchema: GenMessage<UserRBACPermissions> = /*@__PURE__*/
  messageDesc(file_permission, 12);

/**
 * ABAC 约束（合并后）
 *
 * @generated from message puppy.proto.v1.RoleConstraints
 */
export type RoleConstraints = Message<"puppy.proto.v1.RoleConstraints"> & {
  /**
   * 允许的文件类型（例如扩展名/ MIME，具体以服务端约定为准）
   *
   * @generated from field: repeated string allowed_file_types = 1;
   */
  allowedFileTypes: string[];

  /**
   * 禁止的文件类型
   *
   * @generated from field: repeated string denied_file_types = 2;
   */
  deniedFileTypes: string[];

  /**
   * 允许的 IP 白名单
   *
   * @generated from field: repeated string allowed_ips = 3;
   */
  allowedIps: string[];

  /**
   * 允许的最大文件大小（字节）
   *
   * @generated from field: uint64 max_file_size = 4;
   */
  maxFileSize: bigint;

  /**
   * 允许访问的时间范围（HH:MM-HH:MM，支持跨午夜；多段用逗号分隔）
   *
   * @generated from field: repeated string access_time_ranges = 5;
   */
  accessTimeRanges: string[];
};

/**
 * Describes the message puppy.proto.v1.RoleConstraints.
 * Use `create(RoleConstraintsSchema)` to create a new message.
 */
export const RoleConstraintsSchema: GenMessage<RoleConstraints> = /*@__PURE__*/
  messageDesc(file_permission, 13);

/**
 * 权限角色服务（RBAC/ABAC）
 *
 * @generated from service puppy.proto.v1.PermissionRoleService
 */
export const PermissionRoleService: GenService<{
  /**
   * 获取权限角色列表
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.ListPermissionRoles
   */
  listPermissionRoles: {
    methodKind: "unary";
    input: typeof ListPermissionRolesRequestSchema;
    output: typeof ListPermissionRolesResponseSchema;
  },
  /**
   * 获取权限角色详情
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.GetPermissionRole
   */
  getPermissionRole: {
    methodKind: "unary";
    input: typeof GetPermissionRoleRequestSchema;
    output: typeof PermissionRoleSchema;
  },
  /**
   * 创建权限角色
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.CreatePermissionRole
   */
  createPermissionRole: {
    methodKind: "unary";
    input: typeof CreatePermissionRoleRequestSchema;
    output: typeof PermissionRoleSchema;
  },
  /**
   * 更新权限角色
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.UpdatePermissionRole
   */
  updatePermissionRole: {
    methodKind: "unary";
    input: typeof UpdatePermissionRoleRequestSchema;
    output: typeof PermissionRoleSchema;
  },
  /**
   * 删除权限角色
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.DeletePermissionRole
   */
  deletePermissionRole: {
    methodKind: "unary";
    input: typeof DeletePermissionRoleRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 设置子用户权限角色（RBAC role）
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.SetSubUserRoles
   */
  setSubUserRoles: {
    methodKind: "unary";
    input: typeof SetSubUserRolesRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 获取子用户权限角色（RBAC role）
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.GetSubUserRoles
   */
  getSubUserRoles: {
    methodKind: "unary";
    input: typeof GetSubUserRolesRequestSchema;
    output: typeof GetSubUserRolesResponseSchema;
  },
  /**
   * 应用权限角色到子用户
   *
   * @generated from rpc puppy.proto.v1.PermissionRoleService.ApplyPermissionRoles
   */
  applyPermissionRoles: {
    methodKind: "unary";
    input: typeof ApplyPermissionRolesRequestSchema;
    output: typeof EmptyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_permission, 0);

